import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'SET_FILTER',
  'RESET_FILTER',
  'INSIGHTS_PAGE_TOGGLE_FILTER',
  'APPLY_FILTERS',
]);
